// import react  from "react";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

// import "react-fancybox/lib/fancybox.css";

export default function LawyerUploads({ uploadData, name }) {
  // const [documents, setDocuments] = useState([]);

  // const fileInputRef = useRef(null);
  // console.log(documents);

  // const handleButtonClick = () => {

  //   fileInputRef.current.click();
  // };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setDocuments((prevDocs) => [...prevDocs, file]);
  //   }

  // };
  return (
    <>
      <div className="customerDocument">
        <div className="SectionBoxintro">
          <h4 className="p-0">{name}</h4>
          {/* <div className="uploadedbtn">
            <Tooltip title="Lawyer Uploaded Documents" placement="top" arrow>
              <button className="DefaultHoverbtn " onClick={handleButtonClick}>
                Upload Doument
              </button>
            </Tooltip>
          </div> */}
        </div>
        {/* <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        /> */}
        <div className="customerdocumetnview">
          <div className="orderleadtable" style={{ overflowX: "auto" }}>
            <table className="default-table manage-job-table customerdocumetnviewtable">
              <thead>
                <tr>
                  <th>Sr.no.</th>
                  <th>Document Name</th>
                  <th>Date</th>
                  <th>Uploaded By</th>
                  <th>View</th>
                </tr>
              </thead>

              <tbody>
                {uploadData.length > 0 ? (
                  uploadData.map((uplValue, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>Document-{index + 1}</td>
                      <td>{uplValue.create_date}</td>
                      <th>{uplValue.username}</th>
                      <td>
                        <Tooltip title="View" placement="right" arrow>
                          <Link
                            to={`${uplValue.storage_url}/${uplValue.file_name}`}
                            data-fancybox
                            data-caption="Customer Uploaded Documents"
                          >
                            <i
                              className="text-primary fa fa-eye"
                              aria-hidden="true"
                            ></i>
                          </Link>
                        </Tooltip>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No documents found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
